import { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import SignaturePad from 'react-signature-canvas'
import '../formcomponents/ElectronicSignature.css'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { Typography, Button } from '@nwh-consumer-digital/nw-component-lib'
import ErrorMessage from '../formcomponents/errorMessage'
import { Grid, Box, Paper, Stack, useMediaQuery } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal, faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
library.add(fal, faCircleExclamation)

const Item = styled(Paper)(({ theme }) => ({
  textAlign: 'left',
  minHeight: '65px',
  lineHeight: '60px',
}))

const styles = {
  signatureSectionCont: {
    padding: '10px',
  },
  errorMsgCont: {
    display: 'grid',
    clear: 'both',
    width: '100%',
    paddingTop: '40px',
  },
}

const adultPageThree = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  const { updateProgress } = useProgress()
  updateProgress(75)

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  // Scroll to top when page mounts
  useEffect(() => {
    scrollToTop()
  }, [])

  // Setup Ref for Signature Pad Container and Handle Error States  const cardRef = useRef(null)
  const cardRef = useRef(null)

  const removeBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '1px solid #cccccc'
    }
  }
  const addBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '3px solid red'
    }
  }

  const handleSignature = () => {
    setTimeout(() => {
      setIsSigned(true)
    }, 300)
    removeBottomBorderRed()
  }

  const { SubmissionState, onFormStateChange } = props
  const { register, handleSubmit, setValue } = useForm()
  const [isSigned, setIsSigned] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const signData = useRef({})

  const proxyAccessLevel = SubmissionState.sectionTwoForm?.proxyAccessLevel
  const proxyName =
    SubmissionState.sectionTwoForm?.firstNameGuardian + ' ' + SubmissionState.sectionTwoForm?.lastNameGuardian

  const setCardColor = (color) => {
    const sigPadElements = document.getElementsByClassName('SigPad')
    if (sigPadElements[0]) {
      sigPadElements[0].style.backgroundColor = color
    }
    if (cardRef.current) {
      cardRef.current.style.backgroundColor = color
    }
  }

  const clear = () => {
    setImageURL('reset')
    addBottomBorderRed()
    setIsSigned(false)
    signData.current.clear()
    setCardColor('#FAFAFA')
  }

  const save = () => {
    const dataUrl = signData.current.getTrimmedCanvas().toDataURL('image/png')
    setImageURL(dataUrl)
    setValue('imageURLStr', 'True')
    setCardColor('#E8F0FE')
    setIsSigned(true)
  }

  const saveIfNotEmpty = () => {
    if (signData.current.isEmpty()) {
      setIsSigned(false)
    } else {
      save()
    }
  }

  const handleRegistration = (data) => {
    if (imageURL) {
      setValue('imageURLStr', 'True')
      setIsSigned(true)
    }

    data.imageUrl = imageURL
    data.uploadFiles = 'See Folder Images'
    SubmissionState.sec = data
    SubmissionState.sectionThreeForm = data
    SubmissionState.sectionThreSubmitted = true
    SubmissionState.goBackPageOne = false
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackLogin = false
    SubmissionState.goPageFour = true
    SubmissionState.submitCompletedForm = false
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.showPageThree = false
    SubmissionState.showPageTwo = true
    SubmissionState.goBackPageTwo = true
    SubmissionState.goPageThree = false
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: {
              xs: '1.25rem',
              sm: '1.25rem',
              md: '1.25rem',
              lg: '2rem',
              xl: '2rem',
            },
            marginBottom: {
              xs: '2rem',
              sm: '2rem',
              md: '2rem',
              lg: '2rem',
              xl: '2rem',
            },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; Su información</IformBreadcrumb>
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <Item elevation={0}>
            <Typography variant="h1" style={{ marginBottom: 24 }}>
              Firma del solicitante
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography variant="h2" style={{ marginLeft: -4, marginBottom: 16, fontSize: 20 }}>
              Reconozco y acepto que:
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography type="body" size="large" weight="light">
              <ul>
                <li>Debo cumplir los términos y condiciones del sitio web de Northwell.</li>
                <li>
                  El apoderado que se menciona abajo tendrá acceso a mi cuenta de MyNorthwell de la manera que se
                  especifica arriba, que incluye acceso a mi información médica que actualmente esté disponible y a la
                  que pueda estar disponible como consecuencia de la atención médica futura.
                </li>
                <li>El apoderado podría tener acceso a información que yo quiera mantener confidencial.</li>
                <li>
                  Puedo revocar el acceso del apoderado en cualquier momento, visitando la pestaña “Share My Record”
                  (Compartir mi expediente) en el menú de la cuenta de MyNorthwell, haciendo clic en “Friend and family
                  access” (Acceso de amigos y familiares), y haciendo clic en el botón “Revoke” (Revocar) que está junto
                  al nombre de mi apoderado, o presentando por escrito una solicitud de revocación por email a:
                  northwellproxy@northwell.edu
                </li>
                <li>
                  Salvo que revoque el acceso de mi apoderado, seguirá teniendo acceso a mi cuenta de MyNorthwell hasta
                  que yo lo revoque.
                </li>
                <li>
                  Una vez que Northwell comparta mi información médica con mi apoderado, podría volver a revelarse, y es
                  posible que ya no esté protegida por las leyes de privacidad federales y estatales.
                </li>
              </ul>
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" style={{ marginLeft: -10, marginBottom: 16, fontSize: 20 }}>
            Firmando abajo, quiero darle al apoderado que se menciona abajo:{' '}
            <Typography component="span" style={{ fontSize: 20, fontWeight: 'bold' }}>
              {proxyName},{' '}
              {proxyAccessLevel === 'Full Access'
                ? 'Acceso completo'
                : 'Acceso para que solamente pueda ver la información'}
            </Typography>{' '}
            a mi cuenta de MyNorthwell
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div className="Card" ref={cardRef}>
                <Typography type="body" size="small" weight="plain" style={{ marginTop: 10, marginLeft: 16 }}>
                  {' '}
                  Se requiere la firma del paciente adulto<span className="red"> *</span>
                </Typography>
                <div className="SigContainer">
                  <SignaturePad
                    onEnd={handleSignature}
                    penColor="black"
                    canvasProps={{ className: 'SigPad' }}
                    ref={signData}
                  />
                  <div>{!isSigned ? <ErrorMessage message="Se requiere la firma del paciente adulto." /> : null}</div>
                  <Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
                    <Button size="medium" color="primary" onClick={saveIfNotEmpty} type="submit" text="Enviar" />
                    <Button size="medium" color="secondary" onClick={clear} type="button" text="Reiniciar la firma" />
                  </Stack>
                </div>
              </div>
              <input {...register('imageURLStr', { required: true })} type="hidden" />
              <div style={styles.errorMsgCont}></div>
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}

export default adultPageThree
